module.exports = __webpack_public_path__ + "img/step3.652fe7a1.png";